import {
    deepClone
} from '@/util'

import qs from 'qs'
// import jsdw from "@/router/modules/jsdw"
// import add from "@/router/modules/add"
import routes from "@/router/routes"
function hasPermission(permissions, route) {
    let isAuth = false
    if (route.meta && route.meta.auth) {
        isAuth = permissions.some(auth => {
            if (typeof route.meta.auth == 'string') {
                return route.meta.auth === auth
            } else {
                return route.meta.auth.some(routeAuth => {
                    return routeAuth === auth
                })
            }
        })
    } else {
        isAuth = true
    }
    return isAuth
}

// 将多层嵌套路由处理成平级
function flatAsyncRoutes(routes, breadcrumb, baseUrl = '') {
    let res = []
    routes.forEach(route => {
        const tmp = {
            ...route
        }
        if (tmp.children) {
            let childrenBaseUrl = ''
            if (baseUrl == '') {
                childrenBaseUrl = tmp.path
            } else if (tmp.path != '') {
                childrenBaseUrl = `${baseUrl}/${tmp.path}`
            }
            let childrenBreadcrumb = deepClone(breadcrumb)
            if (route.meta.breadcrumb !== false) {
                childrenBreadcrumb.push({
                    path: childrenBaseUrl,
                    title: route.meta.title
                })
            }
            let tmpRoute = deepClone(route)
            tmpRoute.path = childrenBaseUrl
            tmpRoute.meta.breadcrumbNeste = childrenBreadcrumb
            delete tmpRoute.children
            res.push(tmpRoute)
            let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb, childrenBaseUrl)
            childrenRoutes.map(item => {
                // 如果 path 一样则覆盖，因为子路由的 path 可能设置为空，导致和父路由一样，直接注册会提示路由重复
                if (res.some(v => v.path == item.path)) {
                    res.forEach((v, i) => {
                        if (v.path == item.path) {
                            res[i] = item
                        }
                    })
                } else {
                    res.push(item)
                }
            })
        } else {
            if (baseUrl != '') {
                if (tmp.path != '') {
                    tmp.path = `${baseUrl}/${tmp.path}`
                } else {
                    tmp.path = baseUrl
                }
            }
            // 处理面包屑导航
            let tmpBreadcrumb = deepClone(breadcrumb)
            if (tmp.meta.breadcrumb !== false) {
                tmpBreadcrumb.push({
                    path: tmp.path,
                    title: tmp.meta.title
                })
            }
            tmp.meta.breadcrumbNeste = tmpBreadcrumb
            res.push(tmp)
        }
    })
    return res
}

const state = {
    isGenerate: false,
    routes: [],
    headerActived: 0,
}

const getters = {
    sidebarRoutes: state => {
        return state.routes.length > 0 ? state.routes[state.headerActived].children : []
    }
}
function changeMenu(list) {
    var ary = [];
    list.forEach(item => {
        ary.push(item.menuRouter);
    })
    var cusRoute = deepClone(routes)
    cusRoute = cusRoute.filter(item => {
        if (item.children && item.children.length) {
            item.children = item.children.filter(val => {
                if (ary.indexOf(val.path) > -1) {
                    return true
                }
            })
            if (item.path != '/screen') {
                const tmp = list.find(listItem => {
                    
                    return listItem.menuRouter == item.path
                })
                item.orderBy = tmp ? tmp.orderBy : 0;
            }
        }
        return item.children && item.children.length && ary.indexOf(item.path) > -1;
    })
    // console.log(cusRoute);
    cusRoute = cusRoute.sort((a, b) => a.orderBy - b.orderBy);
    return cusRoute;
}
const actions = {
    // 根据权限动态生成路由
    generateRoutes({
        rootState,
        dispatch,
        commit
    }, data) {


        var asyncRoutes = changeMenu(data.asyncRoutes);
        // eslint-disable-next-line no-async-promise-executor

        return new Promise(async resolve => {
            let accessedRoutes
            // 判断权限功能是否开启

            //把请求生成的菜单添加
            var menuData = asyncRoutes


            if (rootState.settings.openPermission) {
                var find = function (arr) {
                    arr.forEach((item, index) => {
                        item.meta = {
                            title: item.text,
                            button: [],
                            auth: [],
                            icon: item.icon,
                        }
                        if (item.ismenu != '1') {
                            item.meta.sidebar = false;
                        }
                        if (item.id.includes('?')) {
                            var tmp = item.id.split('?')
                            item.path = tmp[0]
                            item.meta.param = qs.parse(tmp[1])
                        } else {
                            item.path = item.id
                        }
                        if (item.url) {
                            if (item.url.includes('@')) {
                                item.meta.menucode = item.url.split('@')[1]
                            }
                        }
                        var tmpNameArr = item.path.split('/')
                        item.name = tmpNameArr[tmpNameArr.length - 1]
                        delete item.icon
                        delete item.id
                        delete item.ismenu
                        delete item.rid
                        delete item.sfyw
                        delete item.text
                        delete item.url
                        if (item.children && item.children.length) {
                            var arr = []
                            item.children.forEach((e) => {
                                if (!e.url) {
                                    item.meta.button.push(e)
                                } else {
                                    arr.push(e)
                                }
                            })
                            item.children = arr
                            find(item.children);
                        }
                    });
                };
                find(menuData);
                var menuList = [{
                    children: menuData
                }]
                accessedRoutes = menuList
            } else {
                accessedRoutes = menuData
            }
            // accessedRoutes = accessedRoutes.concat(add)
            commit('setRoutes', accessedRoutes)
            commit('setHeaderActived', data.currentPath)
            let routes = []

            // 如果是按照角色权限动态加载路由的话，options里面只能看到静态的路由，动态加载的路由要在matcher对象的addRoutes里面。
            routes = accessedRoutes;
            if (rootState.settings.enableFlatRoutes) {
                routes.map(item => {
                    if (item.children) {
                        item.children = flatAsyncRoutes(item.children, [{
                            path: item.path,
                            title: item.meta.title
                        }])
                    }
                })
            }
            resolve(routes)
        })
    }
}

const mutations = {

    invalidRoutes(state) {
        state.isGenerate = false
        state.headerActived = 0
    },
    setRoutes(state, routes) {

        state.isGenerate = true
        let newRoutes = deepClone(routes)
        state.routes = newRoutes.filter(item => {
            return item.children.length != 0
        })
    },
    // 根据路由判断属于哪个头部导航
    setHeaderActived(state, path) {

        state.routes.map((item, index) => {
            if (!item.hide &&
                item.children.some(r => {
                    return path.indexOf(r.path + '/') === 0 || path == r.path
                })
            ) {
                state.headerActived = index
            }
        })
    },
    // 切换头部导航
    switchHeaderActived(state, index) {
        state.headerActived = index
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
